/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17.9966 9.9895c-.1242 4.3549-3.6232 7.8647-7.9738 8.0061A8.5228 8.5228 0 0 1 9.75 18C5.1936 18 1.5 14.3063 1.5 9.75c0-4.5564 3.6936-8.25 8.25-8.25S18 5.1936 18 9.75c0 .0801-.0011.16-.0034.2395Zm5.7363 12.6827.0474.0475c.0004.0003-.0003-.0004 0 0 .2919.2929.2926.7681 0 1.0606a.7502.7502 0 0 1-.9568.0868l-.1038-.0868c.0003.0003-.0003-.0003 0 0l-6.626-6.626a10.047 10.047 0 0 1-.1418.1193C14.2665 18.6645 12.1058 19.5 9.75 19.5 4.3652 19.5 0 15.1348 0 9.75S4.3652 0 9.75 0s9.75 4.3652 9.75 9.75c0 2.4224-.8834 4.6385-2.3457 6.3437l6.5786 6.5785ZM10.5 5.25a.75.75 0 0 0-1.5 0V9H5.25a.75.75 0 0 0 0 1.5H9v3.75a.75.75 0 0 0 1.5 0V10.5h3.75a.75.75 0 0 0 0-1.5H10.5V5.25Z"
    clipRule="evenodd"
  />,
  'ZoomIn'
);
